<nz-card>
  <nz-tabset nzType="card" (nzSelectedIndexChange)="onTabChange($event)">
    <nz-header class="site-page-header" nzTitle="Summary"></nz-header>

    <!-- Pending Templates--------------------------------------------------------------------->
    <nz-tab [nzTitle]="titleTemplate1">
      <ng-template #titleTemplate1>
        <span>Pending Templates For Approval</span>
      </ng-template>
      <nz-card nzTitle="Pending Templates For Approval">
        <nz-table
          #templateTable
          [nzBordered]="true"
          [nzData]="templateList"
          [nzSize]="'middle'"
          [nzScroll]="{ x: '100%' }"
        >
          <thead>
            <tr>
              <th nzWidth="25%">User Name</th>
              <th nzWidth="25%">Template Name</th>
              <th nzWidth="25%">Status</th>
              <th nzWidth="25%">Template Type</th>
              <th nzWidth="25%">Created Date</th>
              <!-- <th nzWidth="25%">approve Date</th> -->
              <th nzWidth="25%">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let template of templateTable.data">
              <td>{{ template.userName }}</td>
              <td>{{ template.name }}</td>
              <td>
                <span class="status-active">{{ template.templateStatus }}</span>
              </td>
              <td>{{ template.type }}</td>
              <td>{{ template.createdDate | date : "dd-MM-yyyy HH:mm:ss" }}</td>
              <!-- <td>{{template.approveDate | date: 'dd-MM-yyyy' }}</td> -->

              <td>
                <button
                  nz-button
                  nzType="link"
                  nzShape="circle"
                  nzTooltipTitle="View"
                  (click)="selecttemp(template.name)"
                >
                  <i nz-icon nzType="eye" nzTheme="outline"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </nz-card>
      <nz-drawer
        [nzClosable]="true"
        [nzVisible]="visible"
        nzPlacement="right"
        [nzWidth]="520"
        (nzOnClose)="close()"
      >
        <ng-container *nzDrawerContent>
        <div nz-row [nzJustify]="'center'" [nzGutter]="12" class="margin-top">
          <app-template-preview
            [imageUrl]="imageUrl"
            [validateForm]="validateForm"
            [templateForm]="templateForm"
            [selectedBotId12]="true"
            [type]="templateForm.get('type')?.value || ''"
            [carouselList]="carouselList"
            [alignment]="alignment"
            [orientation]="orientation"
            [uploadedFileName]="
              templateForm.get('documentFileName')?.value || ''
            "
            [messageOrder]="templateForm.get('messageOrder')?.value || ''"
          >
          </app-template-preview>
          </div>
          <div nz-row [nzJustify]="'center'" [nzGutter]="12" class="margin-top">
            <nz-space>
              <button
                *nzSpaceItem
                nz-button
                nzType="primary"
                style="background-color: green; border: none"
                class="btn-gap"
                (click)="updateSatatus('Approved')"
              >
                Approve
              </button>
              <button
                *nzSpaceItem
                nz-button
                nzType="primary"
                style="background-color: red; border: none"
                (click)="updateSatatus('Rejected')"
              >
                Reject
              </button>
            </nz-space>
          </div>
        </ng-container>
      </nz-drawer>
    </nz-tab>

    <!-- Approved Templates------------------------------------------------------------------->
    <nz-tab [nzTitle]="titleTemplate2">
      <ng-template #titleTemplate2>
        <span>Approved Templates</span>
      </ng-template>
      <nz-card nzTitle="Approved Templates">

    <nz-col [nzSpan]="6" style="display: flex; align-items: center; margin-bottom: 2%;">
    <label style="margin-right: 8px; font-weight: 500;">Status</label>
    <nz-select style="width: 100%;" [(ngModel)]="selectedFilter" (ngModelChange)="applyFilter()" [ngModelOptions]="{standalone: true}">
      <nz-option [nzValue]="'Active'" [nzLabel]="'Active'"></nz-option>
      <nz-option [nzValue]="'Inactive'" [nzLabel]="'Inactive'"></nz-option>
    </nz-select>
  </nz-col>

        <nz-table   
          #approvedTable
          [nzBordered]="true"
          [nzData]="filteredTemplateList"
          [nzSize]="'middle'"
          [nzScroll]="{ x: '100%' }"
        >
          <thead>
            <tr>
              <th>User Name</th>
              <th>Template Name</th>
              <th>Operator Status</th>
              <th>Template Type</th>
              <th nzWidth="25%">Created Date</th>
              <th>Approved Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let template of approvedTable.data">
              <td>{{ template.userName }}</td>
              <td>{{ template.name }}</td>
              <td>
                <ng-container
                  *ngIf="template.operatorData.length > 0; else noOp"
                >
                  <div *ngFor="let op of template.operatorData">
                    <strong>{{ op.operatorName }}</strong
                    >: <span style="color: green">{{ op.templateStatus }}</span>
                  </div>
                </ng-container>
                <ng-template #noOp>No operator data</ng-template>
              </td>
              <td>{{ template.type }}</td>
              <td>
                {{
                  template.createadDate !== "N/A" && template.createadDate
                    ? (template.createadDate | date : "dd-MM-yyyy HH:mm:ss")
                    : "N/A"
                }}
              </td>
              <td>
                {{
                  template.approveDate !== "N/A" && template.approveDate
                    ? (template.approveDate | date : "dd-MM-yyyy HH:mm:ss")
                    : "N/A"
                }}
              </td>
              <td>
                <button
                  nz-button
                  nzType="link"
                  nzShape="circle"
                  nzTooltipTitle="View"
                  (click)="tempapprove(template.name)"
                >
                  <i nz-icon nzType="eye" nzTheme="outline"></i>
                </button>
                <a
                  nz-popconfirm
                  [nzPopconfirmTitle]="
                    'Are you sure you want to In activate the template?'
                  "
                  nzPopconfirmPlacement="bottom"
                  (nzOnConfirm)="updatetemplate(template.id)"
                  (nzOnCancel)="cancel()"
                >
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="!approvedTable.data || approvedTable.data.length === 0">
              <td colspan="3">No approved templates found</td>
            </tr>
          </tbody>
        </nz-table>
      </nz-card>
      <nz-drawer
        [nzClosable]="true"
        [nzVisible]="approved"
        nzPlacement="right"
        [nzWidth]="520"
        (nzOnClose)="closeapprove()"
      >
        <ng-container *nzDrawerContent>
          <div
            style="
              position: sticky;
              top: 0;
              height: 85vh;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div
              class="whatsapp-preview-block"
              style="
                width: 300px;
                height: 600px;
                position: relative;
                overflow: hidden;
                background: url('assets/images/mobile-frame.png') no-repeat
                  center;
                background-size: cover;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <!-- Inner Container to Hold Content -->
              <div
                class="innerContainer"
                style="
                  width: 85%;
                  height: 90%;
                  position: absolute;
                  top: 5%;
                  left: 50%;
                  transform: translateX(-50%);
                  background: white;
                  border-radius: 25px;
                  overflow: hidden;
                  overflow-y: auto;
                "
              >
                <div
                  class="header-card"
                  style="
                    position: sticky;
                    top: 0;
                    width: 100%;
                    left: 0;
                    padding: 20px 15px;
                    box-sizing: border-box;
                    z-index: 2;
                    background-color: rgba(255, 255, 255, 0.7);
                    border-radius: 30px 30px 0px 0px;
                    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 5px">
                    <span
                      nz-icon
                      nzType="arrow-left"
                      nzTheme="outline"
                      style="font-size: 12px; color: #333"
                    ></span>
                    <img
                      [src]="imageUrl"
                      alt="VTS Logo"
                      style="
                        height: 20px;
                        width: 20px;
                        border-radius: 50%;
                        object-fit: cover;
                      "
                    />
                    <span
                      style="font-size: 12px; font-weight: bold; color: #333"
                      >{{ botName }}</span
                    >
                  </div>

                  <div style="display: flex; align-items: center; gap: 5px">
                    <span
                      nz-icon
                      nzType="safety-certificate"
                      nzTheme="outline"
                      style="font-size: 20px; color: #333"
                    ></span>
                    <span
                      nz-icon
                      nzType="ellipsis"
                      nzTheme="outline"
                      style="
                        font-size: 20px;
                        transform: rotate(90deg);
                        color: #333;
                      "
                    ></span>
                  </div>
                </div>
                <!-- botLogo-summary -->
                <div
                  class="botLogo-summary"
                  style="
                    position: absolute;
                    top: 18%;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    width: 100%; /* Adjust width as needed */
                  "
                >
                  <!-- Image Container -->
                  <div
                    style="
                      position: relative;
                      width: 70px;
                      height: 70px;
                      overflow: hidden;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <!-- User uploaded image -->
                    <img
                      *ngIf="imageUrl"
                      [src]="imageUrl"
                      style="
                        width: 80%;
                        height: 80%;
                        border-radius: 50%;
                        position: absolute;
                        z-index: 1;
                      "
                    />

                    <!-- Background image overlay -->
                    <div
                      *ngIf="imageUrl"
                      style="
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        background: url('assets/images/verification.png')
                          no-repeat center / contain;
                        z-index: 2;
                      "
                    ></div>
                  </div>

                  <!-- Bot Summary (Now placed below the image) -->
                  <h5
                    style="
                      margin-top: 8px; /* Space between image and text */

                      color: #5b5a5a; /* Adjust text color */
                    "
                  >
                    {{ validateForm.get("botSummary")?.value }}
                  </h5>
                </div>
                <!-- card section -->

                <div
                  *ngIf="
                    selectedTemplate &&
                    templateForm.get('type')?.value !== 'TextMessage' &&
                    templateForm.get('type')?.value !== 'TextMessagewithpdf' &&
                    templateForm.get('type')?.value !== 'carousel'
                  "
                  class="card-container"
                  style="
                    position: absolute;
                    top: 40%;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    z-index: 2;
                  "
                >
                  <div
                    class="card"
                    [ngClass]="{
                      'horizontal-card': orientation === 'HORIZONTAL',
                      'vertical-card': orientation === 'VERTICAL'
                    }"
                    [ngStyle]="{
                      'flex-direction':
                        orientation === 'HORIZONTAL'
                          ? alignment === 'RIGHT'
                            ? 'row-reverse'
                            : 'row'
                          : 'column'
                    }"
                    style="
                      width: 100%;
                      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                      border-radius: 8px;
                      background: white;
                      display: flex;
                      z-index: -1;
                    "
                  >
                    <!-- Card Header (Image Section) -->
                    <div
                      class="card-header"
                      [ngStyle]="{
                        width: orientation === 'HORIZONTAL' ? '30%' : '100%',
                        borderRadius:
                          orientation === 'HORIZONTAL'
                            ? alignment === 'LEFT'
                              ? '8px 0 0 8px'
                              : '0 8px 8px 0'
                            : '8px 8px 0 0',
                        overflow: 'hidden'
                      }"
                    >
                      <img
                        *ngIf="fileUrl"
                        [src]="fileUrl"
                        alt="Uploaded media"
                        [ngStyle]="{
                          height:
                            orientation === 'HORIZONTAL'
                              ? '100%'
                              : imageHeight + 'px',
                          width: '100%',
                          objectFit: 'cover'
                        }"
                        style="display: block"
                      />
                    </div>

                    <!-- Card Content -->
                    <div
                      class="card-content"
                      [ngStyle]="{
               padding: '16px',
               display: 'flex',
               flexDirection: 'column',
               justifyContent: 'center',
             }"
                    >
                      <!-- Card Title -->
                      <!-- Card Title -->
                      <div
                        class="card-title"
                        [ngStyle]="{
                          fontSize: '18px',
                          fontWeight: 'bold',
                          marginBottom: '8px',
                          color: '#333',
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          maxWidth: '100%'
                        }"
                      >
                        {{ templateForm.get("cardTitle")?.value }}
                      </div>

                      <!-- Card Description -->
                      <p
                        class="card-description"
                        [ngStyle]="{
                          width: '100%',
                          fontSize: '14px',
                          color: '#6c6b6b',
                          lineHeight: '1.4',
                          marginBottom: '12px',
                          padding: '5px',
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          maxWidth: '100%'
                        }"
                      >
                        {{ templateForm.get("cardDescription")?.value }}
                      </p>

                      <!-- Suggestion Link -->
                      <div
                        [ngStyle]="{
                          display: 'flex',
                          justifyContent:
                            alignment === 'LEFT' && orientation === 'HORIZONTAL'
                              ? 'flex-start'
                              : alignment === 'RIGHT' &&
                                orientation === 'HORIZONTAL'
                              ? 'flex-end'
                              : 'center',
                          alignItems: 'center',
                          height: '100%'
                        }"
                      >
                        <div>
                          <div
                            *ngFor="
                              let suggestion of suggestionsFormArray.controls;
                              let i = index
                            "
                          >
                            <div
                              *ngIf="suggestion.get('text')?.value"
                              style="margin-top: 10px"
                            >
                              <a
                                nz-button
                                [nzType]="
                                  this.templateType === 'rich_card' ||
                                  this.templateType === 'carousel'
                                    ? 'link'
                                    : 'primary'
                                "
                                [href]="suggestion.get('text')?.value"
                                target="_blank"
                                [ngStyle]="{
                                  color: '#007bff',
                                  fontSize: '14px',
                                  textAlign:
                                    alignment === 'LEFT'
                                      ? 'flex-start'
                                      : alignment === 'RIGHT'
                                      ? 'flex-end'
                                      : 'center'
                                }"
                              >
                                <span
                                  nz-icon
                                  [nzType]="
                                    suggestion.get('type')?.value ===
                                      'view_location_query' ||
                                    suggestion.get('type')?.value ===
                                      'share_location' ||
                                    suggestion.get('type')?.value ===
                                      'view_location_latlong'
                                      ? 'environment'
                                      : suggestion.get('type')?.value ===
                                        'dialer_action'
                                      ? 'phone'
                                      : suggestion.get('type')?.value ===
                                        'url_action'
                                      ? 'global'
                                      : suggestion.get('type')?.value ===
                                        'calendar_event'
                                      ? 'calendar'
                                      : ''
                                  "
                                  nzTheme="outline"
                                ></span>
                                {{ suggestion.get("text")?.value }}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- message content -->
                <div
                  *ngIf="
                    selectedTemplate &&
                    templateForm.get('type')?.value == 'TextMessage'
                  "
                  class="card-container"
                  style="
                    position: absolute;
                    top: 40%;
                    left: 0%;
                    width: 100%;
                    z-index: 2;
                  "
                >
                  <div
                    class="card"
                    style="
                      padding: 5px;
                      width: 100%;
                      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
                      border-radius: 8px;
                      background: white;
                      word-wrap: break-word;
                      white-space: pre-wrap;
                    "
                  >
                    {{ templateForm.get("messagecontent")?.value }}
                  </div>

                  <div
                    style="
                      display: flex;
                      justify-content: flex-start;
                      align-items: center;
                      height: 100%;
                      text-align: center;
                    "
                  >
                    <div>
                      <div
                        *ngFor="
                          let suggestion of suggestionsFormArray.controls;
                          let i = index
                        "
                      >
                        <div
                          *ngIf="suggestion.get('text')?.value"
                          style="margin-top: 10px"
                        >
                          <a
                            nz-button
                            [nzType]="'primary'"
                            [href]="suggestion.get('text')?.value"
                            target="_blank"
                            style="border-radius: 20px"
                          >
                            <span
                              nz-icon
                              [nzType]="
                                suggestion.get('type')?.value ===
                                  'view_location_query' ||
                                suggestion.get('type')?.value ===
                                  'share_location' ||
                                suggestion.get('type')?.value ===
                                  'view_location_latlong'
                                  ? 'environment'
                                  : suggestion.get('type')?.value ===
                                    'dialer_action'
                                  ? 'phone'
                                  : suggestion.get('type')?.value ===
                                    'url_action'
                                  ? 'global'
                                  : suggestion.get('type')?.value ===
                                    'calendar_event'
                                  ? 'calendar'
                                  : ''
                              "
                              nzTheme="outline"
                            ></span>
                            {{ suggestion.get("text")?.value }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- coursel -->
                <nz-carousel
                  nzEffect="scrollx"
                  *ngIf="
                    selectedTemplate &&
                    templateForm.get('type')?.value !== 'TextMessage' &&
                    templateForm.get('type')?.value !== 'TextMessagewithpdf' &&
                    templateForm.get('type')?.value !== 'rich_card'
                  "
                  #carouselRef
                  [nzDots]="false"
                  style="
                    width: 100%;
                    position: absolute;
                    top: 40%;
                    left: 0%;
                    height: 100%;

                    min-height: 160px;
                  "
                >
                  <div
                    class=""
                    *ngFor="let index of carouselList"
                    nz-carousel-content
                    nzEnableSwipe
                    style="text-align: center; overflow: hidden"
                  >
                    <div
                      class="card"
                      style="
                        width: 100%;
                        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                        border-radius: 8px;
                        background: white;
                        display: flex;
                        flex-direction: column;
                        height: auto;
                        max-height: 300px;
                      "
                    >
                      <!-- Card Header (Image Section) -->
                      <div
                        class="card-header"
                        [ngStyle]="{
                          width: '100%',
                          borderRadius: '8px 8px 0 0',
                          overflow: 'hidden',
                          maxHeight: '250px'
                        }"
                      >
                        <img
                          *ngIf="index.mediaUrl"
                          [src]="index.mediaUrl"
                          alt="Uploaded media"
                          [ngStyle]="{ 
                         
                          height:'200px',
                          objectFit: 'fill',
                        }"
                        />
                      </div>

                      <!-- Card Content -->
                      <div
                        class="card-content"
                        [ngStyle]="{
                          padding: '16px',
                          textAlign: 'left',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          width: '100%'
                        }"
                      >
                        <!-- Card Title -->
                        <div
                          class="card-title"
                          style="
                            font-size: 18px;
                            text-align: center;
                            font-weight: bold;
                            margin-bottom: 8px;
                            color: #333;
                          "
                        >
                          {{ index.cardTitle || "Card Title" }}
                        </div>

                        <!-- Card Description -->
                        <p
                          class="card-description"
                          style="
                            font-size: 14px;
                            width: 100%;
                            text-align: center;
                            color: #6c6b6b;
                            line-height: 1.4;
                            margin-bottom: 12px;
                            text-align: center;
                            padding: 5px;
                          "
                        >
                          {{ index.cardDescription || "Card Description" }}
                        </p>

                        <!-- Suggestion Link -->
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 100%;
                            text-align: center;
                          "
                        >
                          <div>
                            <div
                              *ngFor="
                                let suggestion of index.suggestions;
                                let i = index
                              "
                            >
                              <div
                                *ngIf="suggestion.displayText"
                                style="margin-top: 10px"
                              >
                                <a
                                  nz-button
                                  [nzType]="'link'"
                                  target="_blank"
                                  [ngStyle]="{
                                    color: '#007bff',
                                    fontSize: '14px',
                                    textAlign:
                                      alignment === 'LEFT'
                                        ? 'flex-start'
                                        : alignment === 'RIGHT'
                                        ? 'flex-end'
                                        : 'center'
                                  }"
                                >
                                  <span
                                    nz-icon
                                    [nzType]="
                                      suggestion.suggestionType ===
                                        'view_location_query' ||
                                      suggestion.suggestionType ===
                                        'share_location' ||
                                      suggestion.suggestionType ===
                                        'view_location_latlong'
                                        ? 'environment'
                                        : suggestion.suggestionType ===
                                          'dialer_action'
                                        ? 'phone'
                                        : suggestion.suggestionType ===
                                          'url_action'
                                        ? 'global'
                                        : suggestion.suggestionType ===
                                          'calendar_event'
                                        ? 'calendar'
                                        : ''
                                    "
                                    nzTheme="outline"
                                  ></span>
                                  {{ suggestion.displayText }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </nz-carousel>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    gap: 16px;
                    margin-top: 95%;
                  "
                  *ngIf="
                    selectedTemplate &&
                    templateForm.get('type')?.value !== 'TextMessage' &&
                    templateForm.get('type')?.value !== 'TextMessagewithpdf' &&
                    templateForm.get('type')?.value !== 'rich_card'
                  "
                >
                  <button
                    nz-button
                    class="carousel-btn"
                    nzType="link"
                    (click)="prevCard()"
                    nzShape="circle"
                    style="color: white"
                  >
                    <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
                  </button>
                  <button
                    nz-button
                    class="carousel-btn"
                    nzType="link"
                    (click)="nextCard()"
                    nzShape="circle"
                    style="color: white"
                  >
                    <span
                      nz-icon
                      nzType="arrow-left"
                      nzTheme="outline"
                      style="transform: rotate(180deg)"
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </nz-drawer>
    </nz-tab>

    <!-- Active Templates------------------------------------------------------------------------>
    <nz-tab [nzTitle]="titleTemplate3">
      <ng-template #titleTemplate3>
        <span>In Active Templates</span>
      </ng-template>
      <nz-card nzTitle="In Active Templates">
        <nz-table
          #Inactivedata
          [nzBordered]="true"
          [nzData]="getAllInActiveTemplates"
          [nzSize]="'middle'"
          [nzScroll]="{ x: '100%' }"
        >
          <thead>
            <tr>
              <th>User Name</th>
              <th>Template Name</th>
              <th>Operator Status</th>
              <th>Template Type</th>
              <th nzWidth="25%">Created Date</th>
              <th>Approved Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let template of Inactivedata.data">
              <td>{{ template.userName }}</td>
              <td>{{ template.name }}</td>
              <td>
                <ng-container
                  *ngIf="template.operatorData.length > 0; else noOp"
                >
                  <div *ngFor="let op of template.operatorData">
                    <strong>{{ op.operatorName }}</strong
                    >: <span style="color: green">{{ op.templateStatus }}</span>
                  </div>
                </ng-container>
                <ng-template #noOp>No operator data</ng-template>
              </td>
              <td>{{ template.type }}</td>
              <td>
                {{ template.createadDate | date : "dd-MM-yyyy HH:mm:ss" }}
              </td>
              <td>{{ template.approveDate | date : "dd-MM-yyyy HH:mm:ss" }}</td>
              <td>
                <button
                  nz-button
                  nzType="link"
                  nzShape="circle"
                  nzTooltipTitle="View"
                  (click)="tempapprove(template.name)"
                >
                  <i nz-icon nzType="eye" nzTheme="outline"></i>
                </button>
                <a
                  nz-popconfirm
                  [nzPopconfirmTitle]="
                    'Are you sure you want to Activate the template?'
                  "
                  nzPopconfirmPlacement="bottom"
                  (nzOnConfirm)="updatetemplateInactive(template.id)"
                  (nzOnCancel)="cancel()"
                >
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="!Inactivedata.data || Inactivedata.data.length === 0">
              <td colspan="3">No In Active templates found</td>
            </tr>
          </tbody>
        </nz-table>
      </nz-card>
      <nz-drawer
        [nzClosable]="true"
        [nzVisible]="approved"
        nzPlacement="right"
        [nzWidth]="520"
        (nzOnClose)="closeapprove()"
      >
        <ng-container *nzDrawerContent>
          <div
            style="
              position: sticky;
              top: 0;
              height: 85vh;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div
              class="whatsapp-preview-block"
              style="
                width: 300px;
                height: 600px;
                position: relative;
                overflow: hidden;
                background: url('assets/images/mobile-frame.png') no-repeat
                  center;
                background-size: cover;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <!-- Inner Container to Hold Content -->
              <div
                class="innerContainer"
                style="
                  width: 85%;
                  height: 90%;
                  position: absolute;
                  top: 5%;
                  left: 50%;
                  transform: translateX(-50%);
                  background: white;
                  border-radius: 25px;
                  overflow: hidden;
                  overflow-y: auto;
                "
              >
                <div
                  class="header-card"
                  style="
                    position: sticky;
                    top: 0;
                    width: 100%;
                    left: 0;
                    padding: 20px 15px;
                    box-sizing: border-box;
                    z-index: 2;
                    background-color: rgba(255, 255, 255, 0.7);
                    border-radius: 30px 30px 0px 0px;
                    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 5px">
                    <span
                      nz-icon
                      nzType="arrow-left"
                      nzTheme="outline"
                      style="font-size: 12px; color: #333"
                    ></span>
                    <img
                      [src]="imageUrl"
                      alt="VTS Logo"
                      style="
                        height: 20px;
                        width: 20px;
                        border-radius: 50%;
                        object-fit: cover;
                      "
                    />
                    <span
                      style="font-size: 12px; font-weight: bold; color: #333"
                      >{{ botName }}</span
                    >
                  </div>

                  <div style="display: flex; align-items: center; gap: 5px">
                    <span
                      nz-icon
                      nzType="safety-certificate"
                      nzTheme="outline"
                      style="font-size: 20px; color: #333"
                    ></span>
                    <span
                      nz-icon
                      nzType="ellipsis"
                      nzTheme="outline"
                      style="
                        font-size: 20px;
                        transform: rotate(90deg);
                        color: #333;
                      "
                    ></span>
                  </div>
                </div>
                <!-- botLogo-summary -->
                <div
                  class="botLogo-summary"
                  style="
                    position: absolute;
                    top: 18%;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    width: 100%; /* Adjust width as needed */
                  "
                >
                  <!-- Image Container -->
                  <div
                    style="
                      position: relative;
                      width: 70px;
                      height: 70px;
                      overflow: hidden;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <!-- User uploaded image -->
                    <img
                      *ngIf="imageUrl"
                      [src]="imageUrl"
                      style="
                        width: 80%;
                        height: 80%;
                        border-radius: 50%;
                        position: absolute;
                        z-index: 1;
                      "
                    />

                    <!-- Background image overlay -->
                    <div
                      *ngIf="imageUrl"
                      style="
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        background: url('assets/images/verification.png')
                          no-repeat center / contain;
                        z-index: 2;
                      "
                    ></div>
                  </div>

                  <!-- Bot Summary (Now placed below the image) -->
                  <h5
                    style="
                      margin-top: 8px; /* Space between image and text */

                      color: #5b5a5a; /* Adjust text color */
                    "
                  >
                    {{ validateForm.get("botSummary")?.value }}
                  </h5>
                </div>
                <!-- card section -->

                <div
                  *ngIf="
                    selectedTemplate &&
                    templateForm.get('type')?.value !== 'TextMessage' &&
                    templateForm.get('type')?.value !== 'TextMessagewithpdf' &&
                    templateForm.get('type')?.value !== 'carousel'
                  "
                  class="card-container"
                  style="
                    position: absolute;
                    top: 40%;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    z-index: 2;
                  "
                >
                  <div
                    class="card"
                    [ngClass]="{
                      'horizontal-card': orientation === 'HORIZONTAL',
                      'vertical-card': orientation === 'VERTICAL'
                    }"
                    [ngStyle]="{
                      'flex-direction':
                        orientation === 'HORIZONTAL'
                          ? alignment === 'RIGHT'
                            ? 'row-reverse'
                            : 'row'
                          : 'column'
                    }"
                    style="
                      width: 100%;
                      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                      border-radius: 8px;
                      background: white;
                      display: flex;
                      z-index: -1;
                    "
                  >
                    <!-- Card Header (Image Section) -->
                    <div
                      class="card-header"
                      [ngStyle]="{
                        width: orientation === 'HORIZONTAL' ? '30%' : '100%',
                        borderRadius:
                          orientation === 'HORIZONTAL'
                            ? alignment === 'LEFT'
                              ? '8px 0 0 8px'
                              : '0 8px 8px 0'
                            : '8px 8px 0 0',
                        overflow: 'hidden'
                      }"
                    >
                      <img
                        *ngIf="fileUrl"
                        [src]="fileUrl"
                        alt="Uploaded media"
                        [ngStyle]="{
                          height:
                            orientation === 'HORIZONTAL'
                              ? '100%'
                              : imageHeight + 'px',
                          width: '100%',
                          objectFit: 'cover'
                        }"
                        style="display: block"
                      />
                    </div>

                    <!-- Card Content -->
                    <div
                      class="card-content"
                      [ngStyle]="{
               padding: '16px',
               display: 'flex',
               flexDirection: 'column',
               justifyContent: 'center',
             }"
                    >
                      <!-- Card Title -->
                      <!-- Card Title -->
                      <div
                        class="card-title"
                        [ngStyle]="{
                          fontSize: '18px',
                          fontWeight: 'bold',
                          marginBottom: '8px',
                          color: '#333',
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          maxWidth: '100%'
                        }"
                      >
                        {{ templateForm.get("cardTitle")?.value }}
                      </div>

                      <!-- Card Description -->
                      <p
                        class="card-description"
                        [ngStyle]="{
                          width: '100%',
                          fontSize: '14px',
                          color: '#6c6b6b',
                          lineHeight: '1.4',
                          marginBottom: '12px',
                          padding: '5px',
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          maxWidth: '100%'
                        }"
                      >
                        {{ templateForm.get("cardDescription")?.value }}
                      </p>

                      <!-- Suggestion Link -->
                      <div
                        [ngStyle]="{
                          display: 'flex',
                          justifyContent:
                            alignment === 'LEFT' && orientation === 'HORIZONTAL'
                              ? 'flex-start'
                              : alignment === 'RIGHT' &&
                                orientation === 'HORIZONTAL'
                              ? 'flex-end'
                              : 'center',
                          alignItems: 'center',
                          height: '100%'
                        }"
                      >
                        <div>
                          <div
                            *ngFor="
                              let suggestion of suggestionsFormArray.controls;
                              let i = index
                            "
                          >
                            <div
                              *ngIf="suggestion.get('text')?.value"
                              style="margin-top: 10px"
                            >
                              <a
                                nz-button
                                [nzType]="
                                  this.templateType === 'rich_card' ||
                                  this.templateType === 'carousel'
                                    ? 'link'
                                    : 'primary'
                                "
                                [href]="suggestion.get('text')?.value"
                                target="_blank"
                                [ngStyle]="{
                                  color: '#007bff',
                                  fontSize: '14px',
                                  textAlign:
                                    alignment === 'LEFT'
                                      ? 'flex-start'
                                      : alignment === 'RIGHT'
                                      ? 'flex-end'
                                      : 'center'
                                }"
                              >
                                <span
                                  nz-icon
                                  [nzType]="
                                    suggestion.get('type')?.value ===
                                      'view_location_query' ||
                                    suggestion.get('type')?.value ===
                                      'share_location' ||
                                    suggestion.get('type')?.value ===
                                      'view_location_latlong'
                                      ? 'environment'
                                      : suggestion.get('type')?.value ===
                                        'dialer_action'
                                      ? 'phone'
                                      : suggestion.get('type')?.value ===
                                        'url_action'
                                      ? 'global'
                                      : suggestion.get('type')?.value ===
                                        'calendar_event'
                                      ? 'calendar'
                                      : ''
                                  "
                                  nzTheme="outline"
                                ></span>
                                {{ suggestion.get("text")?.value }}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- message content -->
                <div
                  *ngIf="
                    selectedTemplate &&
                    templateForm.get('type')?.value == 'TextMessage'
                  "
                  class="card-container"
                  style="
                    position: absolute;
                    top: 40%;
                    left: 0%;
                    width: 100%;
                    z-index: 2;
                  "
                >
                  <div
                    class="card"
                    style="
                      padding: 5px;
                      width: 100%;
                      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
                      border-radius: 8px;
                      background: white;
                      word-wrap: break-word;
                      white-space: pre-wrap;
                    "
                  >
                    {{ templateForm.get("messagecontent")?.value }}
                  </div>

                  <div
                    style="
                      display: flex;
                      justify-content: flex-start;
                      align-items: center;
                      height: 100%;
                      text-align: center;
                    "
                  >
                    <div>
                      <div
                        *ngFor="
                          let suggestion of suggestionsFormArray.controls;
                          let i = index
                        "
                      >
                        <div
                          *ngIf="suggestion.get('text')?.value"
                          style="margin-top: 10px"
                        >
                          <a
                            nz-button
                            [nzType]="'primary'"
                            [href]="suggestion.get('text')?.value"
                            target="_blank"
                            style="border-radius: 20px"
                          >
                            <span
                              nz-icon
                              [nzType]="
                                suggestion.get('type')?.value ===
                                  'view_location_query' ||
                                suggestion.get('type')?.value ===
                                  'share_location' ||
                                suggestion.get('type')?.value ===
                                  'view_location_latlong'
                                  ? 'environment'
                                  : suggestion.get('type')?.value ===
                                    'dialer_action'
                                  ? 'phone'
                                  : suggestion.get('type')?.value ===
                                    'url_action'
                                  ? 'global'
                                  : suggestion.get('type')?.value ===
                                    'calendar_event'
                                  ? 'calendar'
                                  : ''
                              "
                              nzTheme="outline"
                            ></span>
                            {{ suggestion.get("text")?.value }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- coursel -->
                <nz-carousel
                  nzEffect="scrollx"
                  *ngIf="
                    selectedTemplate &&
                    templateForm.get('type')?.value !== 'TextMessage' &&
                    templateForm.get('type')?.value !== 'TextMessagewithpdf' &&
                    templateForm.get('type')?.value !== 'rich_card'
                  "
                  #carouselRef
                  [nzDots]="false"
                  style="
                    width: 100%;
                    position: absolute;
                    top: 40%;
                    left: 0%;
                    height: 100%;

                    min-height: 160px;
                  "
                >
                  <div
                    class=""
                    *ngFor="let index of carouselList"
                    nz-carousel-content
                    nzEnableSwipe
                    style="text-align: center; overflow: hidden"
                  >
                    <div
                      class="card"
                      style="
                        width: 100%;
                        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                        border-radius: 8px;
                        background: white;
                        display: flex;
                        flex-direction: column;
                        height: auto;
                        max-height: 300px;
                      "
                    >
                      <!-- Card Header (Image Section) -->
                      <div
                        class="card-header"
                        [ngStyle]="{
                          width: '100%',
                          borderRadius: '8px 8px 0 0',
                          overflow: 'hidden',
                          maxHeight: '250px'
                        }"
                      >
                        <img
                          *ngIf="index.mediaUrl"
                          [src]="index.mediaUrl"
                          alt="Uploaded media"
                          [ngStyle]="{ 
                         
                          height:'200px',
                          objectFit: 'fill',
                        }"
                        />
                      </div>

                      <!-- Card Content -->
                      <div
                        class="card-content"
                        [ngStyle]="{
                          padding: '16px',
                          textAlign: 'left',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          width: '100%'
                        }"
                      >
                        <!-- Card Title -->
                        <div
                          class="card-title"
                          style="
                            font-size: 18px;
                            text-align: center;
                            font-weight: bold;
                            margin-bottom: 8px;
                            color: #333;
                          "
                        >
                          {{ index.cardTitle || "Card Title" }}
                        </div>

                        <!-- Card Description -->
                        <p
                          class="card-description"
                          style="
                            font-size: 14px;
                            width: 100%;
                            text-align: center;
                            color: #6c6b6b;
                            line-height: 1.4;
                            margin-bottom: 12px;
                            text-align: center;
                            padding: 5px;
                          "
                        >
                          {{ index.cardDescription || "Card Description" }}
                        </p>

                        <!-- Suggestion Link -->
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 100%;
                            text-align: center;
                          "
                        >
                          <div>
                            <div
                              *ngFor="
                                let suggestion of index.suggestions;
                                let i = index
                              "
                            >
                              <div
                                *ngIf="suggestion.displayText"
                                style="margin-top: 10px"
                              >
                                <a
                                  nz-button
                                  [nzType]="'link'"
                                  target="_blank"
                                  [ngStyle]="{
                                    color: '#007bff',
                                    fontSize: '14px',
                                    textAlign:
                                      alignment === 'LEFT'
                                        ? 'flex-start'
                                        : alignment === 'RIGHT'
                                        ? 'flex-end'
                                        : 'center'
                                  }"
                                >
                                  <span
                                    nz-icon
                                    [nzType]="
                                      suggestion.suggestionType ===
                                        'view_location_query' ||
                                      suggestion.suggestionType ===
                                        'share_location' ||
                                      suggestion.suggestionType ===
                                        'view_location_latlong'
                                        ? 'environment'
                                        : suggestion.suggestionType ===
                                          'dialer_action'
                                        ? 'phone'
                                        : suggestion.suggestionType ===
                                          'url_action'
                                        ? 'global'
                                        : suggestion.suggestionType ===
                                          'calendar_event'
                                        ? 'calendar'
                                        : ''
                                    "
                                    nzTheme="outline"
                                  ></span>
                                  {{ suggestion.displayText }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </nz-carousel>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    gap: 16px;
                    margin-top: 95%;
                  "
                  *ngIf="
                    selectedTemplate &&
                    templateForm.get('type')?.value !== 'TextMessage' &&
                    templateForm.get('type')?.value !== 'TextMessagewithpdf' &&
                    templateForm.get('type')?.value !== 'rich_card'
                  "
                >
                  <button
                    nz-button
                    class="carousel-btn"
                    nzType="link"
                    (click)="prevCard()"
                    nzShape="circle"
                    style="color: white"
                  >
                    <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
                  </button>
                  <button
                    nz-button
                    class="carousel-btn"
                    nzType="link"
                    (click)="nextCard()"
                    nzShape="circle"
                    style="color: white"
                  >
                    <span
                      nz-icon
                      nzType="arrow-left"
                      nzTheme="outline"
                      style="transform: rotate(180deg)"
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </nz-drawer>
    </nz-tab>
  </nz-tabset>
</nz-card>
